import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

//设置主题
export default new Vuetify({
    theme: {
        themes: {
            light: {
                // primary: colors.blue
            }
        }
    },
    customProperties: true,
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
})